<template>
  <Teleport to="body">
    <modal
      :visible="isModalVisible"
      :size="'md'"
      test-id="cybersentriq-announcement-modal"
      @on-close="onModalClose"
      :hide-header="true"
    >
      <slot name="body">
        <div
          class="tw-relative tw-h-[212px] tw-overflow-hidden tw-bg-cover tw-flex tw-justify-center tw-items-center"
          :style="{ backgroundImage: `url(${backgroundImage})` }"
        >
          <button
            class="tw-text-[#ffffff] tw-absolute tw-top-4 tw-right-4"
            data-test-id="cybersentriq-announcement-modal-close-button"
            @click="onModalClose"
          >
            <cl-icon-tabler-x />
          </button>
          <p
            class="tw-text-2xl tw-font-semibold tw-px-40 tw-text-center tw-text-[#ffffff]"
          >
            CyberSentriq:<br />
            Integrated cybersecurity & data protection for MSPs
          </p>
        </div>
        <div class="tw-flex tw-flex-col tw-gap-2 tw-p-6">
          <div
            class="tw-text-left"
            data-test-id="cybersentriq-announcement-text"
          >
            <p class="tw-text-xl tw-text-center tw-font-bold tw-mb-4">
              Microsoft 365 Backup and Recovery
            </p>
            <p class="tw-mb-4">
              CyberSentriq has been purpose-built from the merger of TitanHQ and
              Redstor to provide integrated cybersecurity and data protection to
              MSPs and the customers they service.
            </p>
            <p>
              With this, we're excited to launch our new backup and recovery
              offering—get full-suite protection for Exchange, SharePoint,
              OneDrive, Teams, and OneNote—with instant file recovery.
            </p>
          </div>
          <div class="tw-place-self-center tw-mt-4">
            <cl-button
              variant="secondary-outline"
              data-test-id="cybersentriq-announcement-got-it-button"
              @on-click="onModalClose"
            >
              <span>{{ $t("button-got-it") }}</span>
            </cl-button>
            <cl-button
              variant="secondary"
              data-test-id="cybersentriq-announcement-modal-more-button"
              @on-click="navigateToLink"
            >
              <span>{{ $t("Discover more") }}</span>
            </cl-button>
          </div>
        </div>
      </slot>
    </modal>
  </Teleport>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import Modal from "./modal.vue";
import { useFeatureAnnouncementStore } from "./utils/new-features-announcement";
import { trackEvent } from "@/utils/track-event";
import backgroundImage from "./assets/announcement_banner_cyberSentrig.png";
import { useStore } from "vuex";

const FORM_REDIRECT_URL = "https://www.titanhq.com/microsoft-backup-ui";
const MODAL_KEY = "cybersentriq-announcement-modal";
const MAX_MODAL_VIEWS = 2;
const store = useStore();
const modalStore = useFeatureAnnouncementStore();

const isModalVisible = ref<boolean>(false);
const user = store.getters["authentication/authUser"];

const navigateToLink = () => {
  trackEvent({
    category: "Cybersentriq Announcement",
    action: "Cybersentriq Announcement learn more link clicked",
    name: "",
  });
  window.open(
    `${FORM_REDIRECT_URL}?email=${user.email}&company=${user.organisation}&referrer=platform`,
    "_blank",
  );
};
const onModalClose = () => {
  isModalVisible.value = false;
};
onMounted((): void => {
  if (modalStore.canShow(MODAL_KEY, MAX_MODAL_VIEWS).value) {
    isModalVisible.value = true;
    modalStore.increment(MODAL_KEY);
    modalStore.markAsShown(MODAL_KEY);
  }
});
</script>
